/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const APIPaginationCursorBasedSchema = z.object({
  total: z.number().int().min(0),
  limit: z.number().int().min(1),
  nextCursor: z.string().optional(),
  hasMore: z.boolean(),
});

export type IAPIPaginationCursorBased = z.infer<typeof APIPaginationCursorBasedSchema>;
